import { render, staticRenderFns } from "./AlertBanners.vue?vue&type=template&id=0caa3b9b&"
import script from "./AlertBanners.vue?vue&type=script&lang=js&"
export * from "./AlertBanners.vue?vue&type=script&lang=js&"
import style0 from "./AlertBanners.vue?vue&type=style&index=0&id=0caa3b9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports